<template>
  <div
    style="width: 100%;background-color: #137D5A;height: 200px;display: flex; flex-direction: column; justify-content: center;align-items: center;">

    <div style="width: 1200px; height: 160px; display: flex; justify-content: space-between;">
      <div style="display: flex; align-items: center;">
        <div>
          <img style="cursor: pointer; width: 200px; " src="../assets/image/footer-logo.png" />
          <div class="tip1" style="letter-spacing: 8px;margin-top: 4px;">{{ t('footer.slogan') }}</div>
        </div>
        <div style="width: 200px;height: 1px;"></div>
        <!-- <div style="margin-left: 25px;">
          <div class="tip1">{{ t('footer.life_manager') }}</div>
          <div class="tip1" style="">{{ t('footer.collect_share') }}</div>
          <div class="tip1">{{ t('footer.help_creators') }}</div>
        </div> -->
      </div>
      <div>
        <div class="hot-tip">{{ t('footer.about_seagaa') }}</div>
        <div class="tip" style="margin-bottom: 6px;">{{ t('footer.about_us') }}</div>
        <div class="tip">{{ t('footer.contact_us') }}</div>
      </div>
      <div>
        <div class="hot-tip">{{ t('footer.help') }}</div>
        <div class="tip" style="margin-bottom: 6px;">{{ t('footer.service_agreement') }}</div>
        <div class="tip" style="margin-bottom: 6px;">{{ t('footer.legal_statement') }}</div>
        <div class="tip">{{ t('footer.creator_agreement') }}</div>
      </div>
      <div>
        <div class="hot-tip">{{ t('footer.social_media') }}</div>
        <div class="tip" style="display: flex; align-items: center; margin-bottom: 6px;"><img
            style="width: 18px; height: 18px; margin-right: 8px;" src="../assets/image/douyin.png" alt=""> {{ t('footer.douyin') }}</div>
        <div class="tip" style="display: flex; align-items: center; margin-bottom: 6px;"><img
            style="width: 18px; height: 18px; margin-right: 8px;" src="../assets/image/xiaohongshu.png" alt=""> {{ t('footer.xiaohongshu') }}
        </div>
        <div class="tip" style="display: flex; align-items: center;"><img
            style="width: 18px; height: 18px; margin-right: 8px;" src="../assets/image/bilibili.png" alt=""> {{ t('footer.bilibili') }}
        </div>
      </div>
    </div>

    <div class="bottom">
      <div>{{ t('footer.copyright') }}</div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useI18n } from 'vue-i18n';

export default {
  name: 'FooterMenu',
  components: {
  },
  setup() {
    const { t } = useI18n();
    const language = ref('zh-CN')

    onMounted(() => {

    })


    return {
      t,
      language
    }
  }
}

</script>
<style scoped>
.bottom {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #158A63;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
}

.tip,
.tip1 {
  font-size: 16px;
  color: #FFFFFF;
  line-height: 32px;
}

.tip {
  font-size: 12px;
  line-height: 20px;
}

.tip:hover {
  cursor: pointer;
  color: #FF5D0E;
}

.hot-tip {
  margin-top: 20px;
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 16px;
  color: #FFFFFF;
}
</style>
